export default __webpack_public_path__ + "static/media/en_color.69c08f25.svg";